import ApiAttendance from "../../../gd/api/attendance";

export default async function editAttendance(id: ID, payload: any){

    const app: any = gd.getApp()

    try {
        await ApiAttendance.editAttendance(id, payload).promise()
        await app.init()
        gd.bus.triggerEvent("attendance:update")
        app.reRender()
    } catch (e: any) {
        console.error(e)
    }

}
